var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public-video"},_vm._l((_vm.items),function(video,index){return _c('div',{key:index,staticClass:"public-video-iframe rfider-shadow"},[_c('iframe',{attrs:{"src":video.url,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }